/* eslint-disable no-nested-ternary */
import {
  useState, useRef, useMemo, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash.clonedeep';

import useDeviceType from '../../../hooks/useDeviceType';

import Tooltip from '../../../core/Tooltip';
import Popover from '../../../core/Popover';

import { expDateOrder } from '../../../utils/formatCharts/orderDatetime';
import compare from '../../../../utils/functions/sorting';
import ControlFilter from '../../../../components/Popovers/ControlFilter';
import IconButton from '../../../core/IconButton';
import Button from '../../../core/Button';
import List from '../../../core/List';
import ListItem from '../../../core/ListItem';
import TextArea from '../../../core/TextArea';
import CardKpi from '../CardKpi';

import {
  StyledGridKpiCard,
  Comment,
  // FilterHeader,
  MenuCard,
} from './styled/GridKpisCard.styled';

import {
  Edit,
  Clone,
  MoreVert,
  PNG,
  Info,
  Report,
  AddComment,
  CommentExclamation,
  Filter,
  Fullscreen,
  Trash,
  Control,
  Warning,
  ArrowLeft,
  Export,
  BlockExpand,
  AllowExpand,
} from '../../../icons';
import handleStyleConfig from '../../../../components/KpiCreate/handleStyleConfig';

const deviceThreshold = (device) => {
  switch (device) {
    case 'desktop':
      return 50;
    case 'tablet':
      return 12;
    case 'phone':
      return 4;
    default:
      return 0;
  }
};

const getSorting = (sConfig, firstColumn) => ({
  sortBy: !['Não ordenado', undefined].includes(sConfig?.SortDataControl)
    ? (sConfig?.ColumnToSortControl ?? firstColumn) : '',
  sortOrder: sConfig?.SortDataControl === 'Decrescente' ? 'desc' : 'asc',
});

const emptyFunc = () => {};

const gridKpisCardDefaultPropItem = {};
const gridKpisCardDefaultPropGridKpiState = {};
const gridKpisCardDefaultPropEditCard = () => {};
const gridKpisCardDefaultPropCloneCard = () => {};
const gridKpisCardDefaultPropTransferKpi = () => {};
const gridKpisCardDefaultPropDeleteCard = () => {};
const gridKpisCardDefaultPropOpenCardInfo = () => {};
const gridKpisCardDefaultPropDonwloadReport = () => {};
const gridKpisCardDefaultPropDownloadImgCard = () => {};
const gridKpisCardDefaultPropCreateKpiComment = () => {};
const gridKpisCardDefaultPropOpenModifiersModal = () => {};
const gridKpisCardDefaultPropAutoValueModifiers = () => {};
const gridKpisCardDefaultPropOpenKpiViewer = () => {};
const gridKpisCardDefaultPropGetControlValues = () => {};
const gridKpisCardDefaultPropHandleDynamicKpi = () => {};

const gridKpisCardDefaultPropCardSizes = {
  h: 7, w: 4, x: 0, y: 0,
};

const gridKpisCardDefaultPropDependencyFile = {};
const gridKpisCardDefaultPropGetKpiWithoutDependencyMessage = () => {};
const gridKpisCardDefaultPropViewKpiIdState = ['', () => {}];
const gridKpisCardDefaultPropUpdateKpiShowOnExpand = () => {};

const GridKpisCard = ({
  item = gridKpisCardDefaultPropItem,
  // isSuper,
  isOwner = false,
  gridKpiState = gridKpisCardDefaultPropGridKpiState,
  editCard = gridKpisCardDefaultPropEditCard,
  cloneCard = gridKpisCardDefaultPropCloneCard,
  transferKpi = gridKpisCardDefaultPropTransferKpi,
  deleteCard = gridKpisCardDefaultPropDeleteCard,
  editPainel = false,
  openCardInfo = gridKpisCardDefaultPropOpenCardInfo,
  donwloadReport = gridKpisCardDefaultPropDonwloadReport,
  downloadImgCard = gridKpisCardDefaultPropDownloadImgCard,
  createKpiComment = gridKpisCardDefaultPropCreateKpiComment,
  openModifiersModal = gridKpisCardDefaultPropOpenModifiersModal,
  modifiersQtd = 0,
  openKpiViewer = gridKpisCardDefaultPropOpenKpiViewer,
  autoValueModifiers = gridKpisCardDefaultPropAutoValueModifiers,
  viewKpiIdState = gridKpisCardDefaultPropViewKpiIdState,
  showToPrint = false,
  //
  getControlValues = gridKpisCardDefaultPropGetControlValues,
  handleDynamicKpi = gridKpisCardDefaultPropHandleDynamicKpi,
  // ...props
  cardSizes = gridKpisCardDefaultPropCardSizes,
  globalFilters = undefined,
  globalFiltersOrder = undefined,
  dependencyFile = gridKpisCardDefaultPropDependencyFile,
  canAccessReport = false,
  getKpiWithoutDependencyMessage = gridKpisCardDefaultPropGetKpiWithoutDependencyMessage,
  globalConfig = undefined,
  database = '',
  updateKpiShowOnExpand = gridKpisCardDefaultPropUpdateKpiShowOnExpand,
  cardSelection = emptyFunc,
}) => {
  const device = useDeviceType();
  const kpiRef = useRef();
  const [showControlFilter, setShowControlFilter] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [showCommentContainer, setShowCommentContainer] = useState(false);
  const [isEditComment, setIsEditComment] = useState(false);
  const [comment, setComment] = useState(item.comment || '');

  const [controlSelected, setControlSelected] = useState();
  const [controlOptions, setControlOptions] = useState();

  const [drilldownKeys, setDrilldownKeys] = useState(null);

  const [controlFileError, setControlFileError] = useState();
  const [filteredItem, setFilteredItem] = useState(item);
  const [kpiLoading, setKpiLoading] = useState(false);
  const [toggleMenuCard, setToggleMenuCard] = useState(false);

  const [page, setPage] = useState(0);
  const [viewKpiId, setViewKpiId] = viewKpiIdState;

  useEffect(() => {
    if (item.type === 'SubsetTable') {
      const filteredItemCallback = (setter) => {
        setFilteredItem(({ ...setter(item) }));
      };
      (async () => {
        await handleDynamicKpi(
          item.id,
          item.type,
          item?.meta ?? {},
          item.database,
          filteredItemCallback,
          { page: 0, ...getSorting(item.style, item?.meta?.values?.[0]?.column) },
        );
      })();
    } else {
      setFilteredItem(item);
      setDrilldownKeys(null);
    }
    setControlSelected(null);
  }, [item?.meta]);

  useEffect(() => {
    if (item?.style) {
      setFilteredItem((it) => ({
        ...it,
        name: item.name,
        style: item.style,
      }));
    }
  }, [item?.style]);

  const meta = useMemo(() => (item?.meta ?? {}), [item]);
  const { collection, kpiItemList } = gridKpiState;

  const closeMenu = () => setMenuIsOpen(false);
  const toggleMenu = () => setMenuIsOpen((p) => !p);

  const closeControlFilter = () => setShowControlFilter(false);

  /** @async Load dataframe values from control variable */
  const loadControlValues = async () => {
    if (!editPainel && !controlOptions && meta?.control?.[0]?.column && meta.database) {
      const res = await getControlValues(
        item.database, meta.control[0].column, meta.control[0].map, meta.filters,
      );
      if (res.fileError) {
        setControlFileError(res.fileError);
      } else {
        res.opts.sort((a, b) => (compare(
          expDateOrder(a.label), expDateOrder(b.label),
        )));
        setControlOptions([
          ...res.opts,
        ]);
      }
    }
  };

  const toggleControlFilter = () => setShowControlFilter((p) => {
    if (!p) loadControlValues();
    return !p;
  });

  const handleCardImgDonwload = () => downloadImgCard(kpiRef.current, item.name);

  const handleOpenCardInfo = () => openCardInfo(item);

  const handleOpenFilterValues = () => openModifiersModal(item);

  const handleDelete = () => deleteCard(item);

  const handleEdit = () => editCard(item);

  const handleClone = () => cloneCard(item);

  const handleTransferKpi = () => transferKpi(item);

  const closeCommentContainer = (resetComment) => {
    setShowCommentContainer(false);
    setIsEditComment(false);
    if (resetComment) setComment(item.comment);
  };

  const showOnExpand = () => {
    updateKpiShowOnExpand(item.id, true);
  };

  const hideOnExpand = () => {
    updateKpiShowOnExpand(item.id, false);
  };

  const toggleCommentContainer = () => setShowCommentContainer((p) => !p);
  const showCommentEditor = () => {
    if (isOwner && collection === 'kpis') setIsEditComment(true);
  };
  const showAddComment = () => {
    setShowCommentContainer((p) => !p);
    setIsEditComment(true);
  };

  const onSubmitComment = async () => {
    setShowCommentContainer(false);
    setIsEditComment(false);
    await createKpiComment(comment, item.id);
  };

  const checkComment = () => !!item?.comment?.trim();

  const genControllerFilter = (values) => {
    if (values && values?.length !== controlOptions?.length) {
      return {
        ftype: 'values',
        inverse: false,
        column: meta.control[0].column,
        selector: meta.control[0].map,
        values,
      };
    } return null;
  };

  const genDrilldownFilter = (dataKey) => {
    if (dataKey?.length > 0) {
      const result = meta?.linesMap?.find((line) => line.rule === dataKey);
      return {
        ftype: result?.ftype || 'values',
        inverse: result?.inverse ?? false,
        column: meta?.lines[0].column,
        selector: meta?.lines[0].map,
        values: result ? result.values : [dataKey],
      };
    } return null;
  };

  const genDrildownColFilter = (colKey) => {
    if (colKey?.length > 0) {
      const isValue = meta?.values?.find((v) => v?.column === colKey);
      if (isValue) return null;
      const result = meta?.columnsMap?.find((col) => col.rule === colKey);
      return {
        ftype: result?.ftype || 'values',
        inverse: result?.inverse ?? false,
        column: meta?.columns[0].column,
        selector: meta?.columns[0].map,
        values: result ? result.values : [colKey],
      };
    } return null;
  };

  const genGlobalFilter = () => {
    if (globalFiltersOrder?.current?.length > 0) {
      return globalFiltersOrder?.current?.reduce((aux, fId) => {
        if (globalFilters[fId]) {
          aux.push({
            ftype: globalFilters[fId].ftype,
            inverse: globalFilters[fId].inverse,
            column: globalFilters[fId].column,
            selector: globalFilters[fId].selector,
            values: globalFilters[fId].values,
          });
        }
        return aux;
      }, []);
    }
    return [];
  };

  const genValueModifiers = (modifType, ftype, columnVar, lineVar) => {
    const resList = [];
    // const { meta } = filteredItem;
    const lineName = meta.lines?.[0]?.column;
    const columnName = meta.columns?.[0]?.column;
    if (lineVar && lineName) {
      const modifLine = {
        column: lineName,
        variable: 'line',
        ftype: ftype.replace('not-', ''),
        values: [20],
        inverse: false,
      };
      if (modifType === 'group') {
        modifLine.rule = '[Outros]';
        modifLine.inverse = true;
      }
      resList.push(modifLine);
    }
    if (columnVar && columnName) {
      const modifColumn = {
        column: columnName,
        variable: 'column',
        ftype: ftype.replace('not-', ''),
        values: [20],
        inverse: false,
      };
      if (modifType === 'group') {
        modifColumn.rule = '[Outros]';
        modifColumn.inverse = true;
      }
      resList.push(modifColumn);
    }
    if (modifType === 'group') {
      return {
        filterValues: meta.filterValues ?? [],
        groupValues: resList,
      };
    } return {
      filterValues: resList,
      groupValues: meta.groupValues ?? [],
    };
  };

  const handleTempFilters = async ({
    controlValues = null,
    tablePage = 0,
    ddKeys = null,
    valueModifiers = null,
  }) => {
    if (meta?.errorMessage?.length > 0) return;
    setKpiLoading(true);
    const control = genControllerFilter(controlValues ?? controlSelected);
    const global = genGlobalFilter();
    const drilldownFilter = genDrilldownFilter((ddKeys ?? drilldownKeys)?.dataKey);
    const drilldownColFilter = genDrildownColFilter((ddKeys ?? drilldownKeys)?.colKey);
    let tempFilters = [];

    if (global.length > 0) {
      tempFilters = tempFilters.concat(global);
    }
    if (control) tempFilters.push(control);

    if (drilldownFilter) tempFilters.push(drilldownFilter);
    if (drilldownColFilter) tempFilters.push(drilldownColFilter);
    if (tempFilters.length > 0 || item.type === 'SubsetTable') {
      const tempMeta = cloneDeep(meta);
      if (tempFilters.length > 0) {
        tempMeta.filters = [
          ...tempFilters,
          ...(meta.filters ?? []),
        ];
        if (tempMeta?.drilldown?.length > 0 && drilldownFilter) {
          tempMeta.lines = [...tempMeta.drilldown];
          tempMeta.linesMap = [...tempMeta.drilldownMap ?? []];
        }
      }
      if (ddKeys || drilldownKeys) {
        tempMeta.filterValues = valueModifiers?.filterValues ?? [];
        tempMeta.groupValues = valueModifiers?.groupValues ?? [];
        if (item.style?.DrilldownStyle && item.style?.DrilldownStyle !== 'auto') {
          tempMeta.kpi_type = item.style.DrilldownStyle;
        }
      }
      setPage(tablePage);
      await handleDynamicKpi(
        item.id,
        item.type,
        tempMeta,
        item.database || database,
        setFilteredItem,
        {
          page: tablePage,
          ...getSorting(item.style, tempMeta.values?.[0]?.column ?? ''),
          code: item.code ?? '',
          revision: item.revision ?? 1,
        },
      );
    } else {
      setFilteredItem(item);
      setKpiLoading(false);
    }
  };

  const handlePageChange = (pgState) => {
    const pg = typeof pgState === 'function' ? pgState(page) : pgState;
    handleTempFilters({ tablePage: pg });
  };

  /**
   * Filters kpi data, based on selected control values
   * @param {array} selected Selected values
   */
  const handleControl = (selected) => {
    setControlSelected(selected);
    handleTempFilters({ controlValues: selected });
  };

  const handleDrildown = (dataKey, colKey) => {
    setDrilldownKeys({ dataKey, colKey });
    handleTempFilters({ ddKeys: { dataKey, colKey } });
  };

  const removeDrilldown = () => {
    setDrilldownKeys(null);
    handleTempFilters({ ddKeys: {} });
  };

  const handleGlobalFilters = () => {
    handleTempFilters({});
  };

  const handleTempValuesModifiers = (modifType, ftype, columnVar, lineVar) => {
    const valueModifiers = genValueModifiers(modifType, ftype, columnVar, lineVar);
    handleTempFilters({ valueModifiers });
  };

  useEffect(() => {
    if (globalFilters && Object.keys(globalFilters).length > 0) {
      handleGlobalFilters();
    }
  }, [globalFilters]);

  const getReport = async () => {
    const control = genControllerFilter(controlSelected);
    const global = genGlobalFilter();
    let tempFilters = [];

    if (global.length > 0) {
      tempFilters = tempFilters.concat(global);
    }
    if (control) tempFilters.push(control);

    await donwloadReport(item.id, item?.name, tempFilters);
  };

  const handleOpenMenuCard = () => {
    setToggleMenuCard(true);
  };

  useEffect(() => {
    setToggleMenuCard(menuIsOpen || showCommentContainer || showControlFilter);
  }, [menuIsOpen, showCommentContainer, showControlFilter]);

  const handleHoverCloseMenuCard = () => {
    setToggleMenuCard(menuIsOpen || showCommentContainer || showControlFilter);
  };

  const handleOpenKpiViewer = () => {
    // openKpiViewer(item.id);
    setViewKpiId(item.id);
  };

  const handlePermAutoValueModifiers = (modifType, ftype, columnVar, lineVar) => {
    const { filterValues, groupValues } = genValueModifiers(modifType, ftype, columnVar, lineVar);
    autoValueModifiers(item, filterValues, groupValues);
  };

  const avmHandler = () => {
    if (editPainel) return null;
    if (drilldownKeys) return handleTempValuesModifiers;
    return handlePermAutoValueModifiers;
  };

  useEffect(() => {
    // console.log(filteredItem);
    if (viewKpiId !== null && viewKpiId === item.id) {
      openKpiViewer(
        viewKpiId,
        filteredItem,
        [page, handlePageChange],
        kpiLoading,
        drilldownKeys,
        handleDrildown,
        removeDrilldown,
        avmHandler(),
      );
    }
  }, [viewKpiId, filteredItem, page, kpiLoading]);

  const handleStyleConf = (value, diff) => {
    const newStyle = handleStyleConfig(item.style, value, diff);
    setFilteredItem({ ...item, style: newStyle });
  };
  useEffect(() => {
    setKpiLoading(false);
  }, [filteredItem]);

  const handleCardSelection = () => cardSelection(item);

  return (
    <StyledGridKpiCard
      onMouseEnter={handleOpenMenuCard}
      onMouseLeave={handleHoverCloseMenuCard}
    >
      <Popover
        style={{
          borderRadius: '8px',
          backgroundColor: 'trasparent',
          overflow: 'hidden',
          minWidth: 'auto',
        }}
        offset={[0, 0]}
        open={!editPainel && (device !== 'desktop' || toggleMenuCard)}
        stayOpened
        // closePopover={() => {}}
        direction="right-start"
        customPopperModifier={[
          {
            name: 'preventOverflow',
            options: {
              altBoundary: true,
              altAxis: (cardSizes.x + cardSizes.w) >= deviceThreshold(device),
            },
          },
        ]}
      >
        <Popover.Action>
          <CardKpi
            ref={kpiRef}
            key={item.id + modifiersQtd}
            item={filteredItem}
            editPainel={editPainel}
            id={item.id}
            showToPrint={showToPrint}
            isDataLoading={kpiLoading}
            handleDrilldownClick={
              item?.meta?.drilldown?.length > 0 && !drilldownKeys ? handleDrildown : null
            }
            handleStyleConfig={handleStyleConf}
            drilldownSelected={Boolean(drilldownKeys)}
            removeDrilldown={removeDrilldown}
            globalConfig={{
              ...(globalConfig ?? {}),
              useGlobalTheme: !!globalConfig
                && globalConfig.useGlobalTheme
                && (
                  Boolean(drilldownKeys) && filteredItem.style?.DrilldownStyle && filteredItem.style?.DrilldownStyle !== 'auto' ? (
                    filteredItem.style.DDStyles?.UseGlobalColor !== false
                  ) : (
                    filteredItem.style?.UseGlobalColor !== false
                  )
                ),
              useGlobalFont: !!globalConfig
                && globalConfig.useGlobalFont
                && (
                  Boolean(drilldownKeys) && filteredItem.style?.DrilldownStyle && filteredItem.style?.DrilldownStyle !== 'auto' ? (
                    filteredItem.style.DDStyles?.UseGlobalFont !== false
                  ) : (
                    filteredItem.style?.UseGlobalFont !== false
                  )
                ),
            }}
            collection={collection}
            pageState={[page, handlePageChange]}
            autoValueModifiers={avmHandler()}
            onClick={handleCardSelection}
          />
        </Popover.Action>
        <Popover.Content>
          {!editPainel && (
            <>
              <MenuCard className="menuCard">
                {/* ========== Drilldown Back ========== */}
                {Boolean(drilldownKeys) && (
                  <Tooltip text="Retornar ao gráfico original" direction="left">
                    <IconButton
                      color="secondary"
                      shape="circle"
                      variant="pattern"
                      size={cardSizes.w > 5 ? 'medium' : 'small'}
                      style={{ boxShadow: 'none' }}
                      onClick={removeDrilldown}
                    >
                      <ArrowLeft />
                    </IconButton>
                  </Tooltip>
                )}
                {/* ========== Control Filter ========== */}
                {collection === 'kpis' && meta?.control?.[0]?.column?.length > 0 && (
                  <Popover
                    open={showControlFilter}
                    closePopover={closeControlFilter}
                    stayOpened
                    offset={[-20, 2]}
                    style={{ zIndex: '1050' }}
                  >
                    <Popover.Action>
                      <Tooltip text="Controle" direction="left">
                        <IconButton
                          color={
                            controlSelected && controlSelected?.length !== controlOptions?.length ? 'secondary' : 'primary'
                          }
                          shape="circle"
                          variant="pattern"
                          size={cardSizes.w > 5 ? 'medium' : 'small'}
                          style={{ boxShadow: 'none' }}
                          onClick={toggleControlFilter}
                        >
                          <Control />
                        </IconButton>
                      </Tooltip>
                    </Popover.Action>
                    <Popover.Content>
                      <ControlFilter
                        close={closeControlFilter}
                        controlOptions={controlOptions}
                        controlFilterValues={controlSelected}
                        handleFilter={handleControl}
                        controlVar={meta?.control?.[0]?.column || ''}
                        errorMsg={controlFileError}
                      />
                    </Popover.Content>
                  </Popover>
                )}

                {/* ========== Value Filter ========== */}
                {isOwner
                  && !['label', 'smartLabel', 'BoxPlot', 'ScatterPlot', 'Iframe', 'Histogram', 'Content', 'SubsetTable'].includes(item.type)
                  && collection === 'kpis'
                  && device !== 'phone'
                  && cardSizes.h > 6 && (
                  <Tooltip text="Filtrar valores" direction="left">
                    <IconButton
                      color={modifiersQtd > 0 ? 'secondary' : 'primary'}
                      shape="circle"
                      variant="pattern"
                      size="medium"
                      style={{ boxShadow: 'none' }}
                      onClick={handleOpenFilterValues}
                    >
                      <Filter />
                    </IconButton>
                  </Tooltip>
                )}

                {/* ========== Comment ========== */}
                {(checkComment() || isOwner)
            && device !== 'phone'
            && !['label', 'smartLabel', 'Iframe', 'Content'].includes(item.type)
            && (
              <Popover
                open={showCommentContainer}
                closePopover={closeCommentContainer}
                stayOpened
                offset={[-20, 2]}
                style={{
                  width: '250px', padding: '1rem 1rem', whiteSpace: 'normal', zIndex: '1050',
                }}
              >
                <Popover.Action>
                  {checkComment() ? (
                    <Tooltip text="Ver comentário" direction="left">
                      <IconButton
                        color="secondary"
                        shape="circle"
                        variant="pattern"
                        size="medium"
                        style={{ boxShadow: 'none' }}
                        onClick={toggleCommentContainer}
                      >
                        <CommentExclamation />
                      </IconButton>
                    </Tooltip>
                  ) : isOwner && collection === 'kpis' && (
                    <Tooltip text="Adicionar comentário" direction="left">
                      <IconButton
                        shape="circle"
                        variant="pattern"
                        size={cardSizes.w > 5 ? 'medium' : 'small'}
                        style={{ boxShadow: 'none' }}
                        onClick={showAddComment}
                      >
                        <AddComment />
                      </IconButton>
                    </Tooltip>
                  )}
                </Popover.Action>
                <Popover.Content>
                  <span style={{ color: '#696969', fontSize: '0.85rem', fontWeight: 'bold' }}>Comentário</span>
                  {!isEditComment ? (
                    <Comment
                      onClick={showCommentEditor}
                      isOwner={isOwner}
                      story={collection === 'kpis'}
                    >
                      {item.comment}
                    </Comment>
                  ) : (
                    <div>
                      <TextArea
                        value={comment}
                        label=""
                        onChange={(e) => setComment(e.target.value)}
                        style={{ height: '100px' }}
                      />
                      <div style={{
                        display: 'flex', justifyContent: 'center', gap: '5px', paddingTop: '5px',
                      }}
                      >
                        <Button
                          color="primary"
                          variant="outlined"
                          size="medium"
                          shape="rounded"
                          onClick={() => closeCommentContainer(true)}
                        >
                          Cancelar
                        </Button>
                        <Button
                          color="primary"
                          variant="contained"
                          size="medium"
                          shape="rounded"
                          onClick={onSubmitComment}
                        >
                          Salvar
                        </Button>
                      </div>
                    </div>
                  )}
                </Popover.Content>
              </Popover>
            )}

                {/* ========== Check dependencies ========== */}
                {(!dependencyFile?.allowed && !['label', 'Iframe'].includes(item.type) && device !== 'phone') && (
                  <Tooltip text="Sem acesso ao arquivo de origem" direction="left">
                    <IconButton
                      color="error"
                      shape="circle"
                      variant="pattern"
                      size={cardSizes.w > 5 ? 'medium' : 'small'}
                      className="kpi-options"
                      style={{ boxShadow: 'none' }}
                      onClick={() => getKpiWithoutDependencyMessage(dependencyFile, item)}
                    >
                      <Warning aria-hidden="true" type="button" data-dismiss="modal" aria-label="Close" />
                    </IconButton>
                  </Tooltip>
                )}

                {/* ========== Menu options ========== */}
                <Popover
                  open={menuIsOpen}
                  closePopover={closeMenu}
                  offset={[-20, 2]}
                  style={{ zIndex: '1050' }}
                >
                  <Popover.Action>
                    <Tooltip text="Mais opções" direction="left">
                      <IconButton
                        shape="circle"
                        variant="pattern"
                        size={cardSizes.w > 5 ? 'medium' : 'small'}
                        className="kpi-options"
                        style={{ boxShadow: 'none', transform: 'rotate(90deg)' }}
                        onClick={toggleMenu}
                      >
                        <MoreVert aria-hidden="true" type="button" data-dismiss="modal" aria-label="Close" />
                      </IconButton>
                    </Tooltip>
                  </Popover.Action>
                  <Popover.Content>
                    <List>
                      {isOwner
                        && !['label', 'smartLabel', 'BoxPlot', 'ScatterPlot', 'Iframe', 'Histogram', 'Content'].includes(item.type)
                        && collection === 'kpis'
                        && device !== 'phone'
                        && cardSizes.h <= 6 && (
                        <ListItem noOutline onClick={handleOpenFilterValues}>
                          <Filter />
                          Filtrar valores
                        </ListItem>
                      )}
                      {!['label', 'smartLabel', 'Iframe', 'Content'].includes(item.type) && collection === 'kpis' && (
                        <ListItem noOutline onClick={handleOpenCardInfo}>
                          <Info fill="none" />
                          Informações de KPI
                        </ListItem>
                      )}

                      {!['label', 'smartLabel', 'Iframe', 'Content'].includes(item.type) && (isOwner || canAccessReport) && collection === 'kpis' && (
                        <ListItem noOutline onClick={getReport}>
                          <Report fill="none" />
                          Relatório
                        </ListItem>
                      )}

                      {!['label', 'smartLabel', 'Iframe', 'Content'].includes(item.type) && (
                        <ListItem
                          noOutline
                          onClick={handleCardImgDonwload}
                        >
                          <PNG />
                          Salvar PNG
                        </ListItem>
                      )}
                      {isOwner && collection === 'kpis' && device !== 'phone' && (
                        <>
                          <ListItem noOutline onClick={handleDelete}>
                            <Trash />
                            Apagar
                          </ListItem>

                          <ListItem noOutline onClick={handleEdit}>
                            <Edit />
                            Editar
                          </ListItem>

                          {item.type !== 'Iframe' && (
                            <ListItem noOutline onClick={handleClone}>
                              <Clone />
                              Clonar
                            </ListItem>
                          )}

                          <ListItem noOutline onClick={handleTransferKpi}>
                            <Export />
                            Transferir KPI
                          </ListItem>
                          {(item.showOnExpand === false) && (
                            <ListItem noOutline onClick={showOnExpand}>
                              <AllowExpand width="24" height="24" />
                              Mostrar Kpi na expansão
                            </ListItem>
                          )}
                          {(item.showOnExpand ?? true) && (
                            <ListItem noOutline onClick={hideOnExpand}>
                              <BlockExpand width="24" height="24" />
                              Ocultar Kpi na expansão
                            </ListItem>
                          )}
                        </>
                      )}
                    </List>
                  </Popover.Content>
                </Popover>

                {/* ========== Kpi Viewer ========== */}
                { cardSizes.h > 6 && (item.showOnExpand ?? true) && (
                  <div className="menuItemBottom">
                    <Tooltip text="Expandir" direction="left">
                      <IconButton
                        shape="circle"
                        variant="pattern"
                        size={cardSizes.w > 5 ? 'medium' : 'small'}
                        style={{ boxShadow: 'none' }}
                        onClick={handleOpenKpiViewer}
                      >
                        <Fullscreen />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </MenuCard>
            </>
          )}
        </Popover.Content>
      </Popover>
    </StyledGridKpiCard>
  );
};

GridKpisCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    database: PropTypes.string,
    style: PropTypes.shape({}),
    type: PropTypes.string,
    comment: PropTypes.string,
    showOnExpand: PropTypes.bool,
    data: PropTypes.shape({
      index: PropTypes.arrayOf(PropTypes.string),
    }),
    meta: PropTypes.shape({
      drilldown: PropTypes.arrayOf(PropTypes.shape({})),
      values: PropTypes.arrayOf(PropTypes.shape({
        column: PropTypes.string,
      })),
    }),
  }),
  isOwner: PropTypes.bool,
  gridKpiState: PropTypes.shape({
    collection: PropTypes.string,
    kpiItemList: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  editCard: PropTypes.func,
  cloneCard: PropTypes.func,
  transferKpi: PropTypes.func,
  deleteCard: PropTypes.func,
  openCardInfo: PropTypes.func,
  donwloadReport: PropTypes.func,
  downloadImgCard: PropTypes.func,
  createKpiComment: PropTypes.func,
  editPainel: PropTypes.bool,
  openModifiersModal: PropTypes.func,
  autoValueModifiers: PropTypes.func,
  modifiersQtd: PropTypes.number,
  openKpiViewer: PropTypes.func,
  showToPrint: PropTypes.bool,
  getControlValues: PropTypes.func,
  handleDynamicKpi: PropTypes.func,
  cardSizes: PropTypes.shape({
    h: PropTypes.number,
    w: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  dependencyFile: PropTypes.shape({
    allowed: PropTypes.bool,
  }),
  getKpiWithoutDependencyMessage: PropTypes.func,
  globalConfig: PropTypes.shape({}),
  viewKpiIdState: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  ),
  globalFilters: PropTypes.shape({
    current: PropTypes.objectOf(PropTypes.shape({})),
  }),
  globalFiltersOrder: PropTypes.shape({
    current: PropTypes.arrayOf(PropTypes.string),
  }),
  database: PropTypes.string,
  canAccessReport: PropTypes.bool,
  updateKpiShowOnExpand: PropTypes.func,
  cardSelection: PropTypes.func,
};

export default GridKpisCard;
